/* Some mappings for cargo units defined in database (public.cargo_units) */

import { CUBIC_METER_IN_CUBIC_FEET } from './VolumeUnits';
export const LONG_TON_IN_METRIC_TONS = 1.016047;
export const SHORT_TON_IN_METRIC_TONS = 0.907185;
export const POUND_IN_METRIC_TONS = 0.00045359237;

const massCargoUnits = ['t', 'admt', 'mts', 'bdmt', 'lt', 'kg', 'st'] as const;
const volumeCargoUnits = ['m3', 'ft3', 'cbm', 'scbm ub', 'scbm ob'] as const;

export const reducedUnits = ['mts', 'm3', 'ft3', 'pcs', 'set'];

export type PhysicalQuantity = 'mass' | 'volume';

/** Returns which physical quantity the cargo unit represents */
export function getCargoUnitQuantity(
  cargoUnitName: string,
): PhysicalQuantity | null {
  if (
    massCargoUnits.includes(cargoUnitName as (typeof massCargoUnits)[number])
  ) {
    return 'mass';
  }

  if (
    volumeCargoUnits.includes(
      cargoUnitName as (typeof volumeCargoUnits)[number],
    )
  ) {
    return 'volume';
  }

  return null;
}

/** Returns cargo amount in mt/m3, very naive implementation */
export function cargoAmountToSystemUnit(
  amount: number,
  cargoUnitName: string,
): number {
  switch (cargoUnitName) {
    case 'mts':
    case 'admt':
    case 'bdmt':
    case 't': {
      return amount;
    }
    case 'kg': {
      return amount / 1000;
    }
    case 'scbm ub':
    case 'scbm ob':
    case 'lcbm':
    case 'cbm':
    case 'm3': {
      return amount;
    }
    case 'ft3': {
      return amount / CUBIC_METER_IN_CUBIC_FEET;
    }
    case 'lt': {
      return amount * LONG_TON_IN_METRIC_TONS;
    }
    case 'st': {
      return amount * SHORT_TON_IN_METRIC_TONS;
    }
    case 'set':
    case 'pcs': {
      return amount;
    }
    default: {
      console.error(
        'cargoAmountToSystemUnit: No correct mapping found for cargo unit',
        cargoUnitName,
      );
      return amount;
    }
  }
}

/** Returns system cargo amount in given cargo units */
export function systemAmountToCargoUnit(
  amount: number,
  cargoUnitName: string,
): number {
  return amount / cargoAmountToSystemUnit(1, cargoUnitName);
}
